import gPdf from "@/components/g-pdf/g-pdf";
import PDFDetalhesTitulo from "./PDF/PDFDetalhesTitulo.vue";

const name = 'DetalhesTitulo'

export default {
    name,

    components: {       
        'g-pdf': gPdf,
        PDFDetalhesTitulo
    }, 

    props: { },

    mounted() { 
        this.GetDadosTitulo()
    },

    updated() { },

    data() {
        return { 
            renderiza: false,
            infoTitulo: [],
            TituloId: null,
            executarvisualizacao: 0,
            clienteId: null,
            unidadeId: null,
        }
    },

    methods: { 
        gerarPdf(){
            this.generatePdf()
        },
    
        generatePdf() {
            this.executarvisualizacao++
        },
        retornaTelaTitulos () {
            this.$router.push(`/titulos`)
        },

        direcionaConsultaCliente(clienteId, unidadeId){
            this.$router.push(`/cliente-informacao/${clienteId}/${unidadeId}`)
          },

        GetDadosTitulo() {
            this.$isLoading(true)
            this.axios({
              method: 'get',
              url: process.env.VUE_APP_WEB_API + `Documento/GetDetalhesTitulo/${this.$route.params.id}`,
            })
            .then((response) => {
                this.infoTitulo = response.data.data
                this.clienteId = response.data.data.clienteId
                this.unidadeId = response.data.data.unidadeId
            })
            .finally(()=> {
                this.$isLoading(false)
              })
        },
        imprimir()
        {
            this.renderiza = true
            this.TituloId = this.$route.params.id
            this.executarvisualizacao++
        },
    },

    computed: { }, 
};